import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal, ModalFooter } from "react-bootstrap";
import DmsService from "../../../../core/service/DmsService";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";

const FolderCreate = ({ t, show, close, parentId, regulation }) => {
  //const [show, setShow] = useState(true);
  //const handleClose = () => setShow(false);

  const [folderName, setFolderName] = useState("");
  const handleCreate = (e) => {
    e.preventDefault();
    var params;
    if (parentId) {
       params = {
        name: folderName,
        container: {
          id: parentId,
        },
      };
    } else {
       params = {
        name: folderName
      };
    }
    DmsService.createRegulationDoc(regulation, params)
      .then((response) => {
        if (response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setFolderName("");
          close();
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        setFolderName("");
        var errorRes = error.response;
        // if (errorRes.status === 400) {
        //   // toast.error(errorRes.data.message, {
        //   //   position: toast.POSITION.TOP_RIGHT,
        //   // });
        //   close();
        // } else {
        //   toast.error(error.message, {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
        // }
        close();
      });
  };
  return (
    <Modal
      show={show}
      onHide={close}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
      < Modal.Title as="h5">{t("CreateNewFolder.label")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <label className="mb-1">{t("EnterFolderName.label")}</label>
          <input
            type="text"
            className="form-control"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
          />
        </div>
      </Modal.Body>
      <ModalFooter>
        <Button variant="secondary" className="me-2" onClick={close}>
          {t("Close.label")}
        </Button>
        <Button variant="primary" onClick={handleCreate} className="sbmBtn">
          {t("Create.label")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default withTranslation()(FolderCreate);
